import React, { useEffect, useState } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import Swal from "sweetalert2";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { formatCNPJ } from "../../Services/formatCNPJ";

const usuarioAtivo = (usuario) =>
  Number(usuario?.situacao) === 1 ||
  String(usuario?.situacao || "").toLowerCase() === "ativo";

export default function VincularProcessoUsuarios() {
  const [clientes, setClientes] = useState([]);
  const [processos, setProcessos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);

  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [processoSelecionado, setProcessoSelecionado] = useState(null);

  // Snapshot do backend
  const [usuariosComPermissaoInicial, setUsuariosComPermissaoInicial] =
    useState([]);

  // Estado editável
  const [usuariosComPermissao, setUsuariosComPermissao] = useState([]);

  const [filtroClientes, setFiltroClientes] = useState("");
  const [filtroProcessos, setFiltroProcessos] = useState("");
  const [filtroUsuarios, setFiltroUsuarios] = useState("");

  const { authReady } = useAuthContext();
  const { IDOperador, nome, operador } = useOperador();
  const navigate = useNavigate();

  let idFormatado = String(IDOperador).padStart(6, "0");

  // Proteção de rota
  useEffect(() => {
    if (!operador && !authReady) navigate("/");
  }, [operador, authReady, navigate]);

  useEffect(() => {
    carregarClientes();
    carregarUsuarios();
  }, []);

  const carregarClientes = async () => {
    const res = await api.get("/clientes");
    setClientes(res.data);
  };

  const carregarUsuarios = async () => {
    const res = await api.get("/operadores");
    setUsuarios(Array.isArray(res.data) ? res.data.filter(usuarioAtivo) : []);
  };

  const carregarProcessos = async (idCliente) => {
    const res = await api.get(`/processo/cliente/${idCliente}`);
    setProcessos(res.data);
  };

  const carregarUsuariosComPermissao = async (idProcesso) => {
    const res = await api.get(`/processo/operador-processo/${idProcesso}`);

    let lista = [];

    if (Array.isArray(res.data)) lista = res.data;
    else if (Array.isArray(res.data?.data)) lista = res.data.data;
    else if (Array.isArray(res.data?.rows)) lista = res.data.rows;
    else if (res.data?.IDOperador) lista = [res.data];

    const ids = lista.map((u) => u.IDOperador);

    setUsuariosComPermissaoInicial(ids);
    setUsuariosComPermissao(ids);
  };

  // Cliente mudou
  useEffect(() => {
    setProcessoSelecionado(null);
    setProcessos([]);
    setUsuariosComPermissao([]);
    setUsuariosComPermissaoInicial([]);

    if (clienteSelecionado) {
      carregarProcessos(clienteSelecionado);
    }
  }, [clienteSelecionado]);

  // Processo mudou
  useEffect(() => {
    if (processoSelecionado) {
      carregarUsuariosComPermissao(processoSelecionado);
    } else {
      setUsuariosComPermissao([]);
      setUsuariosComPermissaoInicial([]);
    }
  }, [processoSelecionado]);

  // Filtros
  const clientesFiltrados = clientes.filter((c) =>
    `${c.nome} - ${formatCNPJ(c.cnpj)}`
      .toLowerCase()
      .includes(filtroClientes.toLowerCase())
  );

  const processosFiltrados = processos.filter((p) =>
    p.descricao.toLowerCase().includes(filtroProcessos.toLowerCase())
  );

  const usuariosFiltrados = usuarios.filter((u) =>
    `${String(u.IDOperador).padStart(6, "0")} - ${u.nome}`
      .toLowerCase()
      .includes(filtroUsuarios.toLowerCase())
  );

  const toggleUsuario = (idUsuario) => {
    setUsuariosComPermissao((prev) =>
      prev.includes(idUsuario)
        ? prev.filter((id) => id !== idUsuario)
        : [...prev, idUsuario]
    );
  };

  // SALVAR
  const handleSalvar = async () => {
    if (!clienteSelecionado || !processoSelecionado) {
      Swal.fire("Atenção", "Selecione cliente e processo.", "info");
      return;
    }

    const removidos = usuariosComPermissaoInicial.filter(
      (id) => !usuariosComPermissao.includes(id)
    );

    const adicionados = usuariosComPermissao.filter(
      (id) => !usuariosComPermissaoInicial.includes(id)
    );

    try {
      for (const idUsuario of removidos) {
        await api.delete(
          `/processo/operadorprocesso/${idUsuario}/${processoSelecionado}`
        );
      }

      for (const idUsuario of adicionados) {
        await api.post("/processo/operador", {
          IDOperador: idUsuario,
          IDProcesso: processoSelecionado,
        });
      }

      Swal.fire(
        "Sucesso!",
        `Adicionados: ${adicionados.length}\nRemovidos: ${removidos.length}`,
        "success"
      );

      // Atualiza snapshot
      setUsuariosComPermissaoInicial(usuariosComPermissao);
    } catch (err) {
      console.error(err);
      Swal.fire("Erro", "Falha ao salvar permissões.", "error");
    }
  };

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nome} />

        <div className="container cadastramento">
          <h2>Vincular Processo a Usuários</h2>

          <div className="grid">
            {/* CLIENTES */}
            <div className="column">
              <h3>Clientes</h3>
              <input
                className="input-filtro show"
                placeholder="Filtrar clientes..."
                value={filtroClientes}
                onChange={(e) => setFiltroClientes(e.target.value)}
              />
              <ul>
                {clientesFiltrados.map((c) => (
                  <li
                    key={c.IDCliente}
                    className={
                      clienteSelecionado === c.IDCliente
                        ? "itemSelecionado"
                        : ""
                    }
                  >
                    <label>
                      <input
                        type="radio"
                        checked={clienteSelecionado === c.IDCliente}
                        onChange={() => setClienteSelecionado(c.IDCliente)}
                      />
                      {c.nome} - {formatCNPJ(c.cnpj)}
                    </label>
                  </li>
                ))}
              </ul>
            </div>

            {/* PROCESSOS */}
            <div className="column">
              <h3>Processos</h3>
              <input
                className="input-filtro show"
                placeholder="Filtrar processos..."
                value={filtroProcessos}
                onChange={(e) => setFiltroProcessos(e.target.value)}
              />
              <ul>
                {processosFiltrados.map((p) => (
                  <li
                    key={p.IDProcesso}
                    className={
                      processoSelecionado === p.IDProcesso
                        ? "itemSelecionado"
                        : ""
                    }
                  >
                    <label>
                      <input
                        type="radio"
                        checked={processoSelecionado === p.IDProcesso}
                        onChange={() => setProcessoSelecionado(p.IDProcesso)}
                      />
                      {p.descricao}
                    </label>
                  </li>
                ))}
              </ul>
            </div>

            {/* USUÁRIOS */}
            <div className="column">
              <h3>Usuários</h3>

              <input
                className="input-filtro show"
                placeholder="Filtrar usuários..."
                value={filtroUsuarios}
                onChange={(e) => setFiltroUsuarios(e.target.value)}
              />

              <ul>
                {usuariosFiltrados.map((u) => {
                  const marcado = usuariosComPermissao.includes(u.IDOperador);

                  return (
                    <li
                      key={u.IDOperador}
                      className={marcado ? "itemSelecionado" : ""}
                    >
                      <label>
                        <input
                          type="checkbox"
                          checked={marcado}
                          onChange={() => toggleUsuario(u.IDOperador)}
                        />
                        {String(u.IDOperador).padStart(6, "0")} - {u.nome}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          <button className="btn-salvar" onClick={handleSalvar}>
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
}
